export const mapAnswersFromAPI = apiQuestion => {
  if (apiQuestion.family === 'single_choice' || apiQuestion.family === 'multiple_choice') {
    const answers = [];
    apiQuestion.answers.choices.forEach(choice => {
      const answer = { answer: choice.text, score: '' };
      if (choice.quiz_options) {
        answer.score = choice.quiz_options.score.toString();
      }
      answers.push(answer);
    });

    return answers;
  }

  return [];
};

export const mapQuestionTypeFromAPI = (family, subtype, displayOptions) => {
  const singleChoiceSubType = subtype === 'vertical' ? 'single_choice' : 'dropdown';
  switch (family) {
    case 'single_choice':
      return singleChoiceSubType;
    case 'multiple_choice':
      return 'multiple_choice';
    case 'open_ended':
      if (subtype === 'single') {
        if (displayOptions && displayOptions.display_type === 'slider') {
          return 'slider';
        }
        return 'single_textbox';
      }
      if (subtype === 'essay') {
        return 'comment_box';
      }
      break;
    case 'matrix':
      if (
        subtype === 'rating' &&
        displayOptions.display_type === 'emoji' &&
        displayOptions.display_subtype === 'star'
      ) {
        return 'star_rating';
      }
      break;
    default:
      return singleChoiceSubType;
  }

  return null;
};
